<template>
  <v-list-item>
    <v-list-item-icon>
      <v-icon>mdi-account-lock</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>パスワード変更</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'PasswordListItem'
}
</script>
